import { StyledSpinner } from './Spinner.styles';

export const Spinner = ({ paddingTop }: { paddingTop?: number }) => {
  return (
    <StyledSpinner
      className="spinner-container"
      style={{
        paddingTop: paddingTop || 0,
      }}
    >
      <div
        className="logo-cont scale-out-center"
        style={{
          height: '40px',
          width: '40px',
        }}
      >
        <div className="shape1 fade-in4"></div>
        <div className="shape2 fade-in3"></div>
        <div className="shape3 fade-in5"></div>
        <div className="shape4 fade-in"></div>
        <div className="shape5 fade-in2"></div>
      </div>
    </StyledSpinner>
  );
};
